
import formAPIDoctorFavLabs from "./lab";


var formattedOutput = null;

const formAPIModelDoctorFavLabs = (data) => {
  // Apply formAPIModel to each item in the data array
  formattedOutput = data.map(item => formAPIDoctorFavLabs(item));


  return formattedOutput
};

export default formAPIModelDoctorFavLabs